/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/common-utils';
import { Icon, Link, Text } from '@zapier/design-system';
import { Step } from './types';

type HeldTaskStepItemProps = Step & {
  numOfStepsDone: number;
};

const checkStyle = css`
  position: absolute;
  left: -25px;
`;

const rootStyle = (props: HeldTaskStepItemProps) => [
  css`
    display: list-item;
    margin-right: ${props.numOfStepsDone > 0 || props.isDone ? 26 : 0}px;
    position: relative;
  `,
  props.isDone &&
    css`
      text-decoration: line-through;
    `,
];

function HeldTaskStepItem(props: HeldTaskStepItemProps) {
  return (
    <li css={rootStyle(props)}>
      {props.isDone && (
        <span css={checkStyle}>
          <Icon name="formCheckCircle" size={20} />
        </span>
      )}
      <Link href={props.ctaUrl}>{props.cta}</Link>
      &nbsp;
      <Text color="grey700" type="altText900">
        {props.description}
      </Text>
    </li>
  );
}

export default HeldTaskStepItem;
